<div style="max-width: 600px">
  <img style="max-width: 600px" [src]="content.photoUrl1">
  <p style="font-weight: bold; font-size: large; margin-top: 10px">{{content.title}}</p>
  <p style="font-size: medium">{{content.content}}</p>
  <div mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>OK</button>
  </div>
</div>
